import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import PremiseListScreen from './screens/PremiseListScreen';
import EditPremiseScreen from './screens/EditPremiseScreen';
import PremiseDetailScreen from './screens/PremiseDetailScreen';

ManagePremises.propTypes = {};

function ManagePremises(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0">
                <Routes>
                    <Route path="" element={<PremiseListScreen />} />
                    <Route path="/:premiseId" element={<PremiseDetailScreen />} />
                    <Route path="/add" element={<EditPremiseScreen />} />
                    <Route path={"/:premiseId/edit"} element={<EditPremiseScreen />} />
                    <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default ManagePremises;
